<div id="side-nav-container"
     class="sidenav_container" *ngIf="IsAuthenticated"
     [@onSideNavChange]="sideNavState ? 'open' : 'close'">
    <div fxLayout="column" style="height: 100%;" >
        <div>
            <mat-nav-list>
                <a mat-list-item class="hyperlink-group"
                   *ngFor="let feature of featurelist" id="{{feature?.id}}">

                    <div class="feature-item" matTooltip="{{feature.mouseover}}"
                         matTooltipPosition="right"
                         routerLink="{{feature?.link}}"
                         routerLinkActive="active-list-item">

                        <img
                                style="width:20px; height:20px; border: none; outline: none;"
                                *ngIf="isIcon(feature.icon)===false" id="icon-{{feature?.id}}"
                                routerLink="{{feature?.link}}"  src="assets/{{feature.icon}}.png"/>

                        <mat-icon *ngIf="isIcon(feature.icon)===true" id="icon-{{feature?.id}}"
                                  routerLink="{{feature?.link}}">{{feature?.icon}}</mat-icon>

                        <span class="feature-text" routerLink="{{feature?.link}}"
                              [@animateText]="linkText ? 'hide' : 'show'" >{{ feature?.name }} </span>
                    </div>
                </a>
            </mat-nav-list>
        </div>

        <div style="height:20px;"></div>
        <div class="resources-site-style" *ngIf="visibleResourceSite"
             matTooltip="Launch The Connector's Resources Site"
             matTooltipPosition="right"
             (click)="doLaunchResourcesSite()">
            Resources Site

        </div>

    </div>
</div>
